import { THEME } from '../../../themes';
import { ConnectionScoreEnum } from '../../../enums/connection-score.enum';

export const scoreColorByLevel: {[key: string]: string} = {
  [ConnectionScoreEnum.LowConnection]: THEME.COLORS.PRIMARY,
  [ConnectionScoreEnum.MediumConnection]: THEME.COLORS.ACCENT,
  [ConnectionScoreEnum.StrongConnection]: THEME.COLORS.SECONDARY,
};
